export const timestamp = seconds => `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`

// Minutes, seconds and tenths, e.g. 1315.4 -> "21:55.4".
export const preciseTimestamp = seconds => {
  const tenths = Math.round(seconds * 10)
  const minutes = Math.floor(tenths / 600)
  const rest = tenths - minutes * 600
  return `${minutes}:${String(Math.floor(rest / 10)).padStart(2, '0')}.${rest % 10}`
}

// A clip's range in the same clock format as the event list, with its length.
export const clipRange = (start, end) => {
  const from = Number(start)
  const to = Number(end)
  if (start == null || end == null || !Number.isFinite(from) || !Number.isFinite(to)) return `${start ?? '—'} → ${end ?? '—'}`
  return `${preciseTimestamp(from)} – ${preciseTimestamp(to)} · ${(to - from).toFixed(1)} s`
}

export function timelineEntries (highlights, review) {
  const plays = review?.events?.length
    ? review.events.map(event => ({
      id: `event:${event.id}`,
      type: 'play',
      title: event.title,
      description: `${event.observation} ${event.attribution}`,
      start: event.start_seconds,
      end: event.end_seconds,
      event
    }))
    : review?.coaching
      ? review.coaching.key_plays.map(play => {
        const evidence = review.findings.filter(f => play.evidence_ids.includes(f.id))
        return { id: `play:${evidence[0]?.id}`, type: 'play', title: play.title, description: play.why_it_matters, start: Math.min(...evidence.map(f => f.start_seconds)), end: Math.max(...evidence.map(f => f.end_seconds)) }
      })
      : []
  return [
    ...(review?.segments || []).map(s => ({ id: `index:${s.id}`, type: 'index', title: s.title, description: s.overview, start: s.start_seconds, end: s.end_seconds, segment: s })),
    ...highlights.map(h => ({ id: `highlight:${h.id}`, type: 'highlight', title: h.name, description: h.description, start: h.start, end: h.end, highlight: h })),
    ...plays
  ].filter(e => Number.isFinite(e.start) && Number.isFinite(e.end) && e.start >= 0 && e.end > e.start)
    .sort((a, b) => a.start - b.start || b.end - a.end || a.id.localeCompare(b.id))
}

// Allocate separate rows for simultaneous clips. A shift and its plays can overlap.
export function timelineLanes (entries) {
  const lanes = []
  return entries.map(entry => {
    let lane = lanes.findIndex(end => end <= entry.start)
    if (lane < 0) lane = lanes.length
    lanes[lane] = entry.end
    return { ...entry, lane }
  })
}
